import React from "react";

import ItemTypeSet, { MIN_WIDTH, SPACE_BETWEEN } from "components/base/ItemTypeSet";
import { getScrollbarWidth, useMainContentWidth } from "utils/ScreenUtil";
import { useFormContext } from "react-hook-form";
import { useDispatch } from "react-redux";

const TypeSelectArea = ({
  title = "",
  typeFieldName = "type",
  extraValueChangeAction = () => { },
  typeConfig = []
}) => {
  const dispatch = useDispatch()
  const mainContentWidth = useMainContentWidth();
  const fullContainerWith = mainContentWidth - 80 - 60 - getScrollbarWidth();
  const {
    watch,
    setValue,
  } = useFormContext();
  const watchType = watch(typeFieldName)
  return (
    <>
      {title && <div className="create-section-label">{title}</div>}
      <div
        className="step-type-area"
        style={{
          justifyContent:
            fullContainerWith < (MIN_WIDTH + SPACE_BETWEEN) * 2
              ? 'center'
              : 'flex-start',
        }}
      >
        {typeConfig.map((typeItem, idx) => (
          <ItemTypeSet
            key={`${idx}-${typeItem.id}`}
            item={typeItem}
            selected={watchType}
            onClick={(id)=>{
              if (watchType === id) {
                return;
              }
              setValue(typeFieldName, id, { shouldDirty: true });
              extraValueChangeAction && extraValueChangeAction({ dispatch, value: id })
            }}
          />
        ))}
      </div>
    </>
  )
}

export default TypeSelectArea;
